import { Injectable } from '@angular/core';
import { PlatformApiWpService } from './platform-apiwp.service';
import { CommonConfig } from '../shared/common-config/common-config';
import { MareTranslateService } from './mare-translate.service';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { catchError, of } from 'rxjs';
import { ProductService } from './product.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  orders!: any[];
  convertedOrders!: any[];
  promise!: Promise<{orders: any[], convertedOrders: any[]}>;

  constructor(
    private platformApiWpService: PlatformApiWpService,
    private commonConfig: CommonConfig,
    private mareTranslateService: MareTranslateService,
    private eventInteractionService: EventInteractionService,
    private productService: ProductService
  ) { }


  getOrders(force?: boolean): Promise<{orders: any[], convertedOrders: any[]}> {

    if (!force && (this.promise !== undefined && this.promise.constructor.name === 'Promise' && this.promise.hasOwnProperty('_state'))) {
      const promise: any = this.promise;
      if (promise._state === undefined || promise._state === null || promise._state === 'pending') {
        return this.promise;
      }
    }

    this.promise = new Promise((resolve, reject) => {

      if(this.orders != undefined && !force) {
        resolve({orders: this.orders, convertedOrders: this.convertedOrders});
      }

      this.platformApiWpService.getRequest('msc/v1/getorders', false,true).then((sub: any) => {
        sub.pipe(
          catchError((err: any) => of([]))
        ).subscribe(async (response: any) => {
          console.log('__init orders ________________', response);
          if (response && response.status == 'ok') {
            this.orders = response.payload;
            this.convertedOrders = [];

            for (let order of this.orders) {
              let newRow = {
                orderNumber: order.id,
                orderDate:order.date_created.date,
                status: this.getTranslatedStatus(order.status),
                total: order.total,
                products: this.getProducts(order),
                orderItems: new Array<any>(),
                orderRaw: order,
                orderElement:order
              }
              newRow.orderItems = await this.getProductsItems(order.items);
              
              this.convertedOrders.push(newRow);
            }
          } else {
            console.log(response);
            this.orders = [];
            this.convertedOrders = [];
          }
          resolve({orders: this.orders, convertedOrders: this.convertedOrders});
        }, (err: any) => {
          console.log(err);
          this.orders = [];
          this.convertedOrders = [];
          reject({orders: this.orders, convertedOrders: this.convertedOrders});
        });
      }).catch((err: any) => {
        console.log(err);
        this.orders = [];
        this.convertedOrders = [];
        reject({orders: this.orders, convertedOrders: this.convertedOrders});
      });
    })

    return this.promise;

  }

  getTranslatedStatus(status: string): string {
    switch (status) {
      case 'pending':
        return 'in attesa';
      case 'processing':
        return 'in elaborazione';
      case 'completed':
        return 'completato';
      case 'cancelled':
        return 'cancellato';
    }
    return '';
  }

  getProducts(order: any) {
    let products: any[] = [];
    order.items.forEach((product: any) => {
      // let item = product.name + " " + product.total + "€";
      let item = product.name ;
      products.push(item);
    });
    return products.join(', ');
  }

  async getProductsItems(productItems: any) {
    let productsItems: any[] = [];
    
    // let productIds = productItems.reduce((acc:string, curr:any) => {
    //   return acc + (acc === '' ? '' : ',') + curr.product_id;
    // })
    let productIds: number[] = [];
    productIds = productItems.map((el:any)=>{
      return el.product_id
    })
   
    return await this.productService.getProductById(productIds);
  }

}
